import { Characteristic, CharacteristicType } from "./_types";

export const LIB_CHARS_KIWI_HARVEST: Characteristic[] = [

    //* APPEARANCE
    {
        id: "kiwi_frut_pubescence",
        type: CharacteristicType.Nominal,
        categoryId: "frut_appearance",
        label: "Pubescence",
        params: {
            options: [
                { value: "smooth",      label: "Smoot" },
                { value: "very_sparse", label: "Very sparse" },
                { value: "sparse_fine", label: "Sparse, fine, short hair (Hort16A)" },
                { value: "medium",      label: "Medium (Hayward)" },
                { value: "very_hairy",  label: "Very hairy and dense (Bruno)" },
            ]
        }
    },

    //* COLOUR AND PATTERN
    {
        id: "kiwi_skin_colour",
        type: CharacteristicType.Nominal,
        label: "Skin Colour",
        categoryId: "frut_color_pattern",
        params: {
            options: [
                { value: "light_green",  label: "Light green" },
                { value: "medium_green", label: "Medium-green" },
                { value: "green_brown",  label: "Greenish brown (Hayward)" },
                { value: "yellow_brown", label: "Yellow-brown" },
                { value: "red_brown",    label: "Reddish-brown" },
                { value: "medium_brown", label: "Medium-brown (Topstar Vantini)" },
                { value: "dark_brown",   label: "Dark brown" },
                { value: "other",        label: "Other" },
            ]
        }
    },
    // TODO VERIFY THESE COLOURS
    {
        id: "kiwi_skin_colour_pick",
        type: CharacteristicType.Color,
        label: "Skin Colour",
        categoryId: "frut_color_pattern",
        params: {
            palette: [
                { h: 95,  s: 35, l: 55, label: "Light green" },
                { h: 95,  s: 35, l: 40, label: "Medium-green" },
                { h: 50,  s: 25, l: 38, label: "Greenish brown" },
                { h: 38,  s: 35, l: 43, label: "Yellow-brown" },
                { h: 20,  s: 35, l: 40, label: "Reddish-brown" },
                { h: 32,  s: 33, l: 35, label: "Medium-brown" },
                { h: 25,  s: 33, l: 22, label: "Dark brown" },
            ]
        }
    },
    {
        id: "kiwi_flesh_colour",
        type: CharacteristicType.Nominal,
        label: "Flesh Colour",
        categoryId: "frut_color_pattern",
        params: {
            options: [
                { value: "light_green",  label: "Light green" },
                { value: "dark_green",   label: "Dark green" },
                { value: "yellow_green", label: "Yellow-green" },
                { value: "yellow",       label: "Yellow" },
                { value: "white_yellow", label: "White-yellow" },
                { value: "gold_yellow",  label: "Golden yellow" },
                { value: "purple_red",   label: "Purple red" },
                { value: "full_red",     label: "Full red" },
                { value: "green_red",    label: "Green-red" },
                { value: "yellow_red",   label: "Yellow-red" },
                { value: "other",        label: "Other" },
            ]
        }
    },
    {
        id: "kiwi_flesh_colour_pick",
        type: CharacteristicType.Color,
        label: "Flesh Colour",
        categoryId: "frut_color_pattern",
        params: {
            palette: [
                { h: 88,  s: 65, l: 65, label: "Light green" },
                { h: 110, s: 60, l: 38, label: "Dark green" },
                { h: 70,  s: 65, l: 52, label: "Yellow-green" },
                { h: 54,  s: 80, l: 60, label: "Yellow" },
                { h: 55,  s: 40, l: 85, label: "White-yellow" },
                { h: 44,  s: 85, l: 52, label: "Golden yellow" },
                { h: 335, s: 70, l: 40, label: "Purple red" },
                { h: 355, s: 75, l: 45, label: "Full red" },
                { h: 75,  s: 50, l: 42, label: "Green-red" },
                { h: 35,  s: 80, l: 50, label: "Yellow-red" },
            ]
        }
    },

    //* SHAOE AND SYMMETRY
    {
        id: "kiwi_shape_type",
        type: CharacteristicType.Nominal,
        label: "Shape Type",
        categoryId: "frut_shape_symmetry",
        params: {
            options: [
                { value: "elliptic",    label: "Elliptic" },
                { value: "oblong",      label: "Oblong" },
                { value: "ovate",       label: "Ovate" },
                { value: "obovate",     label: "Obovate" },
                { value: "oblate",      label: "Oblate" },
                { value: "fusiform",    label: "Fusiform" },
                { value: "circular",    label: "Circular" },
            ]
        }
    },

    //* POSTHARVEST PESTS
    {
        id: "kiwi_postharv_pest_ident",
        type: CharacteristicType.Nominal,
        label: "Postharvest Pest Identification",
        categoryId: "frut_postharv_pests",
        params: {
            options: [
                { value: "stink_bugs",    label: "Stink bugs" },
                { value: "fruit_flies",    label: "Fruit flies" },
            ]
        }
    },

    //* POSTHARVEST DAMAGE, DISORDERS AND DEFECTS
    {
        id: "kiwi_postharv_defect_ident",
        type: CharacteristicType.Nominal,
        label: "Internal and External Defects and Damage Identification",
        categoryId: "frut_postharv_defects",
        params: {
            options: [
                { value: "shrivelling",         label: "Shrivelling" },
                { value: "skin_cracking",       label: "Skin cracking" },
                { value: "sunscald",            label: "Sunscald" },
                { value: "rain_marks",          label: "Rain marks" },
                { value: "blemish_stain",       label: "Blemishes and stains" },
                { value: "dehydrated_fruit",    label: "Dehydrated fruit" },
                { value: "pitting",             label: "Pitting" },
                { value: "storage_breakdown",   label: "Storage breakdown" },
                { value: "overripe",            label: "Overripe" },
                { value: "russeting",           label: "Russeting" },
                { value: "black_grey_spots",    label: "Black or grey spots" },
                { value: "skin_scuffs",         label: "Skin rubs or scuffs" },
                { value: "hayward_marks",       label: "Hayward marks" },
                { value: "misshapen_fruit",     label: "Misshapen fruit" },
                { value: "flats_fans",          label: "Flats and fans" },
                { value: "carbon_dioxide",      label: "Carbon dioxide Injury" },
                { value: "chill_injury",        label: "Chilling injury" },
                { value: "internal_browning",   label: "Internal browning" },
                { value: "freezing_damage",     label: "Freezing damage" },
            ]
        }
    },


]